// extracted by mini-css-extract-plugin
export var quantityInput = "_hx-0";